export const userFormSchema = {
    type: 'object',
    required: [],
    properties: {
        firstName: {
            type: 'string'
        },
        lastName: {
            type: 'string'
        },
        emailAddress: {
            type: 'string'
        },
        office: {
            type: 'string'
        },
        emptyRow: {
            type: 'string'
        },
        securityGroupId: {
            type: 'string',
            enum: [],
            enumNames: []
        },
        userStatus: {
            type: 'string',
            enum: ["ACTIVE", "INACTIVE"],
            enumNames: ["Active", "Inactive"]
        },
    }
};

export const userFormUiSchema = (hasOffice, isStatusEnabled, isManageUsers) => ({
    'ui:field': 'widget',
    firstName: {
        'ui:autofocus': 'true',
        'lwolf:classNames': 'col-md-6',
        classNames: 'form-group',
        'ui:title': 'First Name',
        "ui:readonly": true
    },
    lastName: {
        'lwolf:classNames': 'col-md-6',
        classNames: 'form-group',
        'ui:title': 'Last Name',
        "ui:readonly": true
    },
    emailAddress: {
        'lwolf:classNames': 'col-md-6',
        classNames: 'form-group',
        'ui:title': 'Email Address',
        "ui:readonly": true
    },
    office: {
        'lwolf:classNames': 'col-md-6',
        classNames: 'form-group',
        'ui:title': 'Office',
        "ui:readonly": true,
        'ui:widget': hasOffice ? undefined : 'hidden'
    },
    emptyRow: {
        'ui:widget': 'hrWidget',
        'lwolf:classNames': 'col-md-12 mt-n4',
        'ui:title': " "
    },
    securityGroupId: {
        'lwolf:classNames': 'col-md-6',
        classNames: 'form-group',
        "ui:readonly": !isManageUsers,
        'ui:title': 'Security Group',
    },
    userStatus: {
        'lwolf:classNames': 'col-md-6',
        classNames: 'form-group',
        "ui:readonly": !isManageUsers,
        'ui:title': 'Status',
        'ui:widget': isStatusEnabled ? undefined : 'hidden',
        'ui:readonly': !isManageUsers ?? true
    },
    'ui:order': [
        '*'
    ],
    'lwolf:rows': [
        [
            'firstName',
            'lastName'
        ],
        [
            'emailAddress',
            'office'
        ],
        [
            'emptyRow'
        ],
        [
            'securityGroupId',
            'userStatus'
        ]
    ]
});
